import axiosClient from "axios";
import { Toast } from "vant";

// 开发环境见 .env.development：建议 baseURL 为空，请求以 /wxapi 开头，避免 /api/wxapi 被网关当成 /api/** 而 401
const axios = axiosClient.create({
  baseURL: process.env.VUE_APP_API_BASE_URL ?? "",
  timeout: 10000,
  withCredentials: false,
});

axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (!error.config?.skipErrorToast && (error.msg || error.message)) {
      Toast({
        message: error.msg || error.message,
      });
    }
    return Promise.reject(error);
  }
);

export default axios;
